import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { setAdmin, setUser } from '../../utils/auth';
import useFormInput from '../../hooks/useFormInput';
import { loginAdminApi } from '../../api/admin';
import { loginUserApi } from '../../api/person';
import { connect } from 'react-redux';
import action from '../../store/action';
import CustomForm from '../../components/CustomForm';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
const styles = {
  container: { width: '100%', alignItems: 'center', margin: '25vh auto' }
};

const useStyles = makeStyles(styles);

function Login({ global_action_loading, admin_login, user_login }) {
  const classes = useStyles();

  const username = useFormInput('');
  const password = useFormInput('');
  const [role, setRole] = useState('user');
  const handleLogin = () => {
    global_action_loading();
    if (role === 'admin') {
      loginAdminApi({ username: username.value, password: password.value }).then(res => {
        if (res.data.status === 200) {
          setAdmin(username.value);
          admin_login();
          global_action_loading(false);
        } else {
          alert('wrong');
        }
      });
    } else {
      loginUserApi({ email: username.value, password: password.value }).then(res => {
        if (res.data.status === 200) {
          setUser(res.data.data, res.data.role);
          user_login();
          global_action_loading(false);
        } else {
          alert('wrong');
        }
      });
    }
  };

  return (
    <div className={classes.container}>
      <CustomForm>
        <CustomSelect
          value={role}
          onChange={event => {
            setRole(event.target.value);
          }}
          label='Role'
          options={[
            { value: 'user', label: 'User' },
            { value: 'admin', label: 'Admin' }
          ]}
        />
        <CustomInput required label='Username' {...username} />
        <CustomInput required label='Password' {...password} />
        <Button onClick={handleLogin} color='primary'>
          Login
        </Button>
      </CustomForm>
    </div>
  );
}
export default connect(null, { ...action.person, ...action.globalLoading })(Login);
